
import { defineComponent } from "vue";
import Navigation from "./components/Navigation.vue";
import "bulmaswatch/flatly/bulmaswatch.min.css";

export default defineComponent({
    name: "App",
    components: { Navigation },
});
